@if (state$ | async; as state) {
  @if (state.loading) {
    <!-- two lines where the rows will stand (0127) -->
    <div class="bom-item-order"><div class="bom-item-order-number"><span class="shadow shadow-long"></span></div></div>
    <div class="bom-item-order"><div class="bom-item-order-number"><span class="shadow"></span></div></div>
  } @else if (state.items && state.items.length > 0) {
    @for (item of state.items; track item.orderId) {
      <a class="bom-item-order" [routerLink]="['/orders', item.orderId]">
        <div class="bom-item-order-number" [title]="item.orderNumber">{{ item.orderNumber }}</div>
        <div class="bom-item-order-status">{{ statusLabels[item.status] }}</div>
        <div class="bom-item-order-amount">{{ formatNumber(item.amount) }}</div>
      </a>
    }
  } @else {
    <div class="bom-item-orders-empty">Nie występuje w żadnym zleceniu</div>
  }
}
